import { Component, Input } from '@angular/core'
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { AssetSortingType } from 'app/models/asset-sorting-type'
import { ModalAddDocumentComponent } from 'app/shared/components/modal-add-document/modal-add-document.component'
import { DocumentService } from 'app/services/document.service'
import { Document } from 'app/models/document'

@Component({
  selector: 'app-document-repository',
  templateUrl: './document-repository.component.html',
  styleUrls: ['./document-repository.component.scss']
})
export class DocumentRepositoryComponent {

  @Input('allowAdd') allowAdd: boolean = true
  isExpanded: boolean = false
  search: string
  sortingType: AssetSortingType
  documents: Array<Document>
  bsModalRef: BsModalRef
  lastEvaluatedKey: any

  constructor(
    private modalService: BsModalService,
    private documentService: DocumentService
  ) {
  }

  ngOnDestroy() {
    if (this.bsModalRef) this.bsModalRef.content.close.unsubscribe()
  }

  showModal() {
    this.bsModalRef = this.modalService.show(ModalAddDocumentComponent, {
      class: 'modal-lg',
      backdrop: 'static'
    })
    this.bsModalRef.content.title = 'ADD LINK'

    this.bsModalRef.content.close.subscribe((value) => {
      this.getAll()
      this.bsModalRef.hide()
      this.bsModalRef.content.close.unsubscribe()
    })

  }

  onSorting(sortingType): void {
    this.sortingType = sortingType
    this.getAll()
  }

  onSearch(search: string): void {
    this.search = search
    this.getAll()
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey)
  }

  getAll(lastEvaluatedKey?: string): void {
    this.documentService
      .getAll(this.search, this.sortingType, lastEvaluatedKey)
      .subscribe(data => {
        this.documents = this.documents && lastEvaluatedKey ?
          this.documents.concat(data.Items) : data.Items
        this.lastEvaluatedKey = data.LastEvaluatedKey
      })
  }

  onDocumentDeleted(deletedId: string) {
    this.lastEvaluatedKey = null;
    this.getAll();
  }  
}
